module.exports = __webpack_public_path__ + "static/media/collision-cource.ae98bc97.jpg";